import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/payroll-management-system/tax-and-compliance-management/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "tax-and-compliance-management" entry is kept); the seo block below is a fallback.

export const taxAndComplianceManagement: ContentPage = {
  slug: "payroll-management-system/tax-and-compliance-management",
  template: "hrmsFeature",
  seo: {
    title: "Tax Compliance Simplified for Businesses",
    description: "Master tax compliance with automated updates and detailed reporting. Our system ensures you stay ahead of regulations with minimal effort.",
    keywords: [
      "tax compliance software",
      "payroll tax management",
      "automated tax updates",
      "regulatory compliance system",
      "payroll auditing tools.",
    ],
    ogImage: "/assets/data/seoimages/tax-and-compliance-management.webp",
  },
  leaf: {
    hero: {
      caption: "Tax and Compliance Management",
      title: "Ensure Compliance with Automated Tax Management",
      description: "Manage your payroll taxes and regulatory compliance effortlessly with our comprehensive tax management system.",
      h1: "caption",
    },
    split: {
      title: "Streamline Payroll Accuracy",
      bullets: [
        { title: "Smart Tax Management", description: "Effortlessly handle taxes with automated updates and alerts." },
        { title: "Regulation Alert System", description: "Get timely notifications on compliance changes and updates." },
        { title: "Accurate Payroll Processing", description: "Ensure payroll taxes are precise to minimize penalties." },
        { title: "Comprehensive Reporting Tools", description: "Easily generate and share detailed tax reports for audits." },
      ],
      image: "/assets/images/img/product/hrms/payrollms/tax-and-compliance-management_info.webp",
      imageAlt: "tax-and-compliance-management_info",
    },
    cardsHeading: {
      title: "Key Features of Payroll Management System",
      description: "Optimize Payroll management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Integration with Accounting",
        href: "/hrms-software/payroll-management-system/integration-with-accounting",
        description: "Sync your payroll data directly with your accounting software to streamline financial management and reporting.",
        image: "/assets/images/img/product/hrms/payrollms/integration-with-accounting_image.webp",
        imageAlt: "integration-with-accounting",
      },
      {
        title: "Custom Deductions",
        href: "/hrms-software/payroll-management-system/custom-deductions",
        description: "Tailor deductions for taxes, benefits, and other payroll elements to match your company policies and employee agreements.",
        image: "/assets/images/img/product/hrms/payrollms/custom-deductions.webp",
        imageAlt: "custom-deductions",
      },
      {
        title: "Overtime and Leave Calculations",
        href: "/hrms-software/payroll-management-system/overtime-leave-calculations",
        description: "Streamline how you handle overtime pay and leave deductions, ensuring fairness and compliance in your payroll processes.",
        image: "/assets/images/img/product/hrms/payrollms/overtime-leave-calculations.webp",
        imageAlt: "overtime-leave-calculations",
      },
      {
        title: "Automated Salary Calculation",
        href: "/hrms-software/payroll-management-system/automated-salary-calculation",
        description: "Simplify and expedite salary calculations with automated systems that integrate attendance and performance data, ensuring precise and timely payroll management.",
        image: "/assets/images/img/product/hrms/payrollms/automated-salary-calculation_image.webp",
        imageAlt: "automated-salary-calculation",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Master Tax Compliance with Ease!",
    relatedBlogsKeyword: "tax-and-compliance-management,features-to-look-in-payroll",
    metaKey: "tax-and-compliance-management",
  },
  sections: [],
};
